import React from 'react'
import { useTheme } from '../Context/ThemeContext';

function Colors({ text }) {

    const { primaryColor, secondaryColor, chooseColor, setChooseColor } = useTheme();

    return (
        <div className='font-bold mx-3 flex justify-between items-center' onClick={() => setChooseColor(!chooseColor)}>
            {text && <p className={`mr-3 choose-color cursor-pointer ${primaryColor} hover:${secondaryColor}`}>{text}</p>}
            <i className={`choose-color fa-solid fa-caret-up cursor-pointer ${primaryColor} hover:${secondaryColor}`} style={{ transition: "all 1s ease", transform: `${chooseColor ? "rotate(180deg)" : ""}` }}></i>
        </div>
    )
}

export default Colors